/**
 * Label Lahra Size Chart Manager v1.
 * Works across theme section morphs; does not intercept variant changes.
 * Never makes network requests and never modifies product/cart state.
 */
(() => {
  if (window.__llSizeChartV1Ready) return;
  window.__llSizeChartV1Ready = true;

  let openDialog = null;
  let returnFocus = null;

  function close(dialog) {
    if (dialog && dialog.open) dialog.close();
  }

  function setUnit(dialog, unit) {
    if (unit !== 'cm' && unit !== 'in') return;
    dialog.querySelectorAll('[data-ll-size-chart-table]').forEach((table) => {
      table.hidden = table.dataset.llSizeChartTable !== unit;
    });
    dialog.querySelectorAll('[data-ll-size-chart-unit]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.llSizeChartUnit === unit));
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-ll-size-chart-open], [data-ll-size-chart-close], [data-ll-size-chart-unit]') : null;
    if (!button) return;

    if (button.hasAttribute('data-ll-size-chart-open')) {
      const dialogId = button.getAttribute('data-ll-size-chart-open');
      const dialog = document.getElementById(dialogId || '');
      if (!(dialog instanceof HTMLDialogElement) || !dialog.hasAttribute('data-ll-size-chart-dialog')) return;
      event.preventDefault();
      if (dialog.open) return;
      // Native showModal handles focus trapping and Esc/cancel.
      returnFocus = button;
      setUnit(dialog, 'cm');
      dialog.showModal();
      openDialog = dialog;
      document.documentElement.classList.add('ll-size-chart-active');
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('ll-size-chart-active');
        openDialog = null;
        if (returnFocus && returnFocus.isConnected) returnFocus.focus({ preventScroll: true });
        returnFocus = null;
      }, { once: true });
      return;
    }

    const dialog = button.closest('dialog[data-ll-size-chart-dialog]');
    if (!(dialog instanceof HTMLDialogElement)) return;
    if (button.hasAttribute('data-ll-size-chart-close')) {
      event.preventDefault();
      close(dialog);
    } else if (button.hasAttribute('data-ll-size-chart-unit')) {
      event.preventDefault();
      setUnit(dialog, button.getAttribute('data-ll-size-chart-unit'));
    }
  });

  // Clicking the backdrop closes the popup without changing the selected variant.
  document.addEventListener('click', (event) => {
    if (event.target !== openDialog || !openDialog) return;
    const rect = openDialog.getBoundingClientRect();
    const outside = event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
    if (outside) close(openDialog);
  });
})();
